export default __webpack_public_path__ + "static/media/take-away-disabled.cfd227e5.svg";